var _ = require('lodash');

var s = 1;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;
var ms = s / 1000;
var us = ms / 1000;
var ns = us / 1000;
var timeUnitsList = [{
  unit: 'y',
  amount: y
}, {
  unit: 'd',
  amount: d
}, {
  unit: 'h',
  amount: h
}, {
  unit: 'm',
  amount: m
}, {
  unit: 's',
  amount: s
}, {
  unit: 'ms',
  amount: ms
}, {
  unit: 'µs',
  amount: us
}, {
  unit: 'ns',
  amount: ns
}];

var timeUnits = _.fromPairs(_.map(timeUnitsList, function (el) {
  return [el.unit, el];
}));

module.exports.timeUnits = timeUnits;
/**
 * Formats a number of seconds.
 * @param {number} seconds The number to stringify.
 * @param {string} rounding The unit used for rounding. Defaults to 'ms'.
 * @return {string} The formatted and normalized string.
 */

function stringify(seconds) {
  var rounding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ms';

  if (!(rounding in timeUnits)) {
    throw new Error("Undefined unit: ".concat(rounding));
  }

  if (!_.isNumber(seconds)) {
    throw new Error("Must provide a number, instead provided ".concat(seconds));
  }

  var str = seconds < 0 ? '-' : '';
  var nbr = Math.abs(seconds);
  var shouldStop = false;

  _.forEach(timeUnitsList, function (el) {
    if (shouldStop) {
      return;
    }

    if (el.unit === rounding) {
      shouldStop = true;
    }

    var tmp = el.unit === rounding ? Math.round(nbr / el.amount) : Math.floor(nbr / el.amount);
    nbr -= tmp * el.amount;

    if (tmp !== 0) {
      str += "".concat(tmp).concat(el.unit, " ");
    }
  });

  return str.length > 0 ? str.trim() : "0".concat(rounding);
}

module.exports.stringify = stringify;
var wsRegex = '[ \\t]';
var positiveNumberRegex = '(?:0|[1-9]\\d*)(?:\\.\\d+)?';
var unitRegex = '(?:ns|µs|ms|s|m|h|d|y)';
var elementRegex = "(?:(".concat(positiveNumberRegex, ")").concat(wsRegex, "*(").concat(unitRegex, "))");
var wholeRegex = "^".concat(wsRegex, "*(-)?((?:").concat(wsRegex, "*").concat(elementRegex).concat(wsRegex, "*)+)$");
var element = new RegExp(elementRegex);
var whole = new RegExp(wholeRegex);
/**
 * Parses a string using the Simple Duration Format and returns the number of seconds
 * corresponding to it.
 * @param {string} str The string to parse
 * @return {number} The number of seconds
 */

function parse(str) {
  if (!_.isString(str)) {
    throw new Error('Must pass a string');
  }

  var match = str.match(whole);

  if (!match) {
    throw new Error("".concat(str, " is not valid Simple Duration Format"));
  }

  var negative = match[1] === '-';
  var elements = match[2];
  var re = new RegExp(element.source, 'g');
  var nmatch;
  var counter = 0;

  while ((nmatch = re.exec(elements)) !== null) {
    var nbr = parseFloat(nmatch[1]);
    var unit = nmatch[2];
    counter += nbr * timeUnits[unit].amount;
  }

  return (negative ? -1 : 1) * counter;
}

module.exports.parse = parse;